import React,{useContext} from 'react'
import { StateContext } from '../../context/GlobalState.jsx'
import {GetText} from "../../context/text.js";

function CartItem({item}) {
    // consuming contexts
    let {increaseCount, decreaseCount, removeFromCart, courseUSD, lang} = useContext(StateContext);

    let text = GetText();

    // dteremine whether decrease or remove button to display
    function decreaseButton() {
        if(item.QUANTITY === 1){
            return (
                <button onClick={() => removeFromCart(item)}>
                    <i className="ri-delete-bin-line"></i>
                </button>
            )
                
        } else {
            return (
                <button onClick={() => decreaseCount(item.ID)}>
                    <i className="ri-indeterminate-circle-line"></i>
                </button> 
            )
        }
    }

    // render JSX
    return (
        <div className="cart-detail product-card">
            <div className="product-info-col">

                { item.PHOTO == "" ? <img src="https://zapauto.com.ua/backend/public/images/logo-zapauto.png" alt="product" /> : <img src={item.PHOTO.replace("../", "https://zapauto.com.ua/")} alt="product" /> }

            </div>
            <div className="product-qty-col">

                <h5> <b>{item.MANUFACTURER}</b> | <b>{item.PART_NUMBER}</b></h5>

                { lang === "ua" ? <h5><b>{item.NAME_UA}</b></h5> : ""}
                { lang === "ru" ? <h5><b>{item.NAME_RU}</b></h5> : ""}
                { lang === "en" ? <h5><b>{item.NAME_EN}</b></h5> : ""}


                {/* product price */}
                { lang === "ua" ? <h6>{item.PRICE_USD * courseUSD} грн </h6> : ""}
                { lang === "ru" ? <h6>{item.PRICE_USD * courseUSD} грн </h6> : ""}
                { lang === "en" ? <h6>{item.PRICE_USD * courseUSD} UAH </h6> : ""}
                {text.CartItem.quantity}: {item.QUANTITY}

            </div>
            <div className="product-counter-col">
                <button onClick={() => increaseCount(item.ID)}>
                    <i className="ri-add-circle-line"></i>
                </button>
                <br/>
                {/* decrease or remove button */}
                {decreaseButton()}
                    
            </div>
        </div> 
    )
}

export default CartItem
